import { createSlice } from 'utils/@reduxjs/toolkit';
import { NotificationsState } from './types';
import { reducers } from './reducers';

export const initialState: NotificationsState = {
  notifications: [],
  isVisible: true,
};

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers,
});

export const { actions: notificationsActions } = slice;
export const { reducer: notificationsReducer } = slice;
